import { styled } from "linaria/react";

export default styled('main')`
  background: #fff;
  flex: 1 1 auto;
`;
